import Auth from '../auth/Auth';
import Promotion from "../models/Promotion";
import { WebClient } from './WebClient'

class ApiPromotion extends WebClient {
    async getPromotions(): Promise<Promotion[]> {
        const url = `/promotion`;

        return this.get(url, Auth.getAuthToken()).then(res => {
            if (res.status === 200) {
                return res.data || [];
            }
            return [];
        }).catch(() => { return []; });
    }

    async deletePromotion(promotionId: number): Promise<boolean> {
        const url = `/promotion/${promotionId}`;

        return this.delete(url, Auth.getAuthToken()).then(res => {
            return (res.status === 200);
        }).catch(() => { return false; });
    }

    async savePromotion(promotion: Promotion): Promise<Promotion> {
        const url = `/promotion`;

        return this.post(url, promotion, Auth.getAuthToken()).then(res => {
            if (res.status === 200) {
                return res.data;
            }
            return;
        }).catch(() => { return; });
    }
}

export default new ApiPromotion();
